import Body from '../../atoms/Body';
import Button from '../../atoms/Button';

import { Flex } from '../../../Utils/styles/display';
import { SlackWorkspaceAndChannelsSelectorProps } from './types';

import { LoopIcon } from '../../../controllers/flows/FlowsShareSheetController/ConnectionsController/styles';
import { ConnectionState } from '../../../controllers/flows/FlowsShareSheetController/ConnectionsController/types';

const SlackWorkspaceStateButton = (
  props: SlackWorkspaceAndChannelsSelectorProps,
) => {
  const {
    state,
    onStateChange,
    showSavedButton,
    connectionsList,
    isSavingConnection,
    selectedConnection,
    onSelectedConnectionChange,
  } = props;

  const handleConnectClick = () => {
    if (connectionsList.length > 0) {
      onStateChange(ConnectionState.ConnectionEditState);
      onSelectedConnectionChange([connectionsList[0]]);
    } else {
      onStateChange(ConnectionState.ConnectToSlackState);
    }
  };

  const handleEditClick = () => {
    onStateChange(ConnectionState.ConnectionEditState);
  };

  const handleCloseClick = () => {
    onStateChange(ConnectionState.ConnectionDisplayState);
  };

  switch (state) {
    case ConnectionState.ConnectState:
      return (
        <Button
          size="small"
          variant="text"
          color="primary"
          onClick={handleConnectClick}
        >
          Connect
        </Button>
      );

    case ConnectionState.ConnectionDisplayState:
      return (
        <Button
          size="small"
          variant="text"
          color="primary"
          onClick={handleEditClick}
          disabled={
            connectionsList.length <= 0 || selectedConnection.length === 0
          }
        >
          Edit
        </Button>
      );

    case ConnectionState.ConnectionEditState:
      return (
        <>
          {isSavingConnection && (
            <Flex>
              <LoopIcon icon="sync" color="geekBlue6" size="16px" />
              <Body variant="body2" color="geekBlue6">
                Saving...
              </Body>
            </Flex>
          )}

          {showSavedButton && (
            <Button
              icon="check"
              size="small"
              variant="text"
              color="grayTertiary"
            >
              Saved
            </Button>
          )}

          {!showSavedButton && !isSavingConnection && (
            <Button
              size="small"
              variant="text"
              color="grayTertiary"
              onClick={handleCloseClick}
            >
              Close
            </Button>
          )}
        </>
      );

    default:
      return null;
  }
};

export default SlackWorkspaceStateButton;
